import React from 'react'
import { connect } from 'react-redux'
import Loader from '../../../../shared/components/Loader.jsx'
import { push } from 'react-router-redux'
import { joinXpressGame as joinXpressGameAction } from '../../../../actions/games/creators/index.js'
import { handleGameClick, handleErrorCode, showErrorMessage } from '../GamesPageNewLayout/gameUtils.jsx'

import { Link } from 'react-router'
import SignIn from '../../header/SignIn.jsx'
import { FormattedMessage } from 'react-intl'
import { messages } from '../GamesPageNewLayout/messages.js'

class RecentGames extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      gamblerIdCheckInterval: null,
      recentGames: [],
      page: 1,
      limit: 100,
      hasMoreGames: true,
      showSignIn: false,
    }
  }

  componentDidMount() {
    const gamblerIdCheckInterval = setInterval(() => {
      const { gamblerId } = this.props
      if (gamblerId) {
        this.fetchGameHistory(gamblerId)
        clearInterval(this.state.gamblerIdCheckInterval)
      }
    }, 500)

    this.setState({ gamblerIdCheckInterval })
  }
  // componentDidUpdate(prevProps) {
  //   const { gamblerId } = this.props
  //   console.log('Updated gamblerId:', gamblerId)
  //   if (prevProps.params.categoryId !== gamblerId) {
  //     this.setState({ category: gamblerId }, () => {
  //       this.fetchGamesByCategory(gamblerId)
  //     })
  //   }
  // }

  componentWillUnmount() {
    if (this.state.gamblerIdCheckInterval) {
      clearInterval(this.state.gamblerIdCheckInterval)
    }
  }

  fetchGameHistory = async (gamblerId, page = 1, append = false) => {
    const { limit, recentGames } = this.state

    this.setState({ loading: true })

    try {
      const offset = (page - 1) * limit
      console.log('Fetching with offset:', offset)
      const response = await fetch(
        `/api/games/history?gamblerId=${gamblerId}&limit=${limit}&offset=${offset}`
      )
      const data = await response.json()
      console.log('Game history data:', data)
      const newGames = data.Items.filter(newGame => !recentGames.some(existingGame => existingGame.Id === newGame.Id))

      this.setState(prevState => ({
        recentGames: [...prevState.recentGames, ...newGames],
        loading: false,
        hasMoreGames: newGames.length === limit,
      }))
    } catch (error) {
      console.error('Error fetching game history:', error)
      this.setState({ loading: false })
    }
  }

  openAuthModal = () => {
    const { user } = this.props

    if (user) {
      alert('Игра не доступна')
    } else {
      this.props.dispatch({ type: 'BEGIN_SIGNIN' })
    }
  }

  handleGameClickWrapper = gameId => {
    const { user } = this.props
    this.setState({ isLoading: true })

    handleGameClick(
      gameId,
      user,
      loading => this.setState({ isLoading: loading }),
      errorCode => handleErrorCode(errorCode, showErrorMessage, () => this.openAuthModal())
    )
  }

  handleLoadMore = () => {
    const { gamblerId } = this.props

    if (!gamblerId) {
      console.error('Gambler ID is not defined')
      return
    }

    this.setState(prevState => {
      const newPage = prevState.page + 1
      console.log('New Page:', newPage)

      this.fetchGameHistory(gamblerId, newPage, true)

      return { page: newPage }
    })
  }

  renderGame = game => {
    return (
      <div key={game.Id} className="game-card" onClick={() => this.handleGameClickWrapper(game.Id)}>
        <div className="game-thumbnail">
          { (game.ThumbnailUrl || '').endsWith(".mp4")
          ? (<video poster={game.ThumbnailUrl} autoPlay muted loop controls={false} className="game-image">
              <source src={game.ThumbnailUrl} type="video/mp4" />
            </video>)
          : (<img src={game.ThumbnailUrl} alt={`Game ${game.Name}`} className="game-image" />)
          }
          <h3 className="game-title">{game.Name}</h3>
        </div>
      </div>
    )
  }

  render() {
    const { loading, recentGames, showSignIn } = this.state

    if (loading && recentGames.length === 0) {
      return <Loader />
    }

    return (
      <div className="favorite-games">
        {showSignIn && <SignIn />}

        <Link to="/games">
          <button className="view-all-button">
            <FormattedMessage {...messages.goBackToGames} />
          </button>
        </Link>
        <h1 className="title">
          <FormattedMessage {...messages.recentGames} />
        </h1>

        <div className="game-grid">
          {recentGames.length > 0 ? (
            recentGames.map(this.renderGame)
          ) : (
            <p className="no-favorites">
              <FormattedMessage {...messages.recentGamesNot} />
            </p>
          )}
        </div>

        {/* {hasMoreGames &&  (
          <button className="showAll" onClick={this.handleLoadMore}>
            Показать еще
          </button>
        )} */}
      </div>
    )
  }
}

export default connect(
  (state, dispatch) => {
    const user = state.auth.get('user')
    return {
      gamblerId: user && user.get('gamblerId'),
      languageId: state.application.get('languageId'),
      user,
      dispatch,
    }
  },
  { push, dispatch: dispatch => dispatch, joinXpressGameAction }
)(RecentGames)



// WEBPACK FOOTER //
// ./js/sport-betting/components/pages/RecentGames/RecentGamesPage.jsx